import { render, staticRenderFns } from "./RelatorioEstoqueView.vue?vue&type=template&id=2f491d32&scoped=true"
import script from "./RelatorioEstoqueView.vue?vue&type=script&lang=js"
export * from "./RelatorioEstoqueView.vue?vue&type=script&lang=js"
import style0 from "./RelatorioEstoqueView.vue?vue&type=style&index=0&id=2f491d32&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f491d32",
  null
  
)

export default component.exports